import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import OfferActionDialog from '../OfferActionDialog';

class ConfirmationAction extends Component {
  request = () => {
    this.props.toggleConfirmDialog();
  };

  render() {
    const {
      dialogBody,
      hideCancelButton,
      open,
      toggleConfirmDialog,
      buttonTitle,
    } = this.props;

    return (
      <Fragment>
        <OfferActionDialog
          open={open}
          hideCancelButton={hideCancelButton}
          handleClose={toggleConfirmDialog}
          request={this.request}
          title='Confirmation'
          dialogBody={dialogBody}
          enableMessage={false}
          submitText='Close'
        />
        <button className='button small w-button'>{buttonTitle}</button>
      </Fragment>
    );
  }
}

ConfirmationAction.propTypes = {
  dialogBody: PropTypes.object.isRequired,
  hideCancelButton: PropTypes.bool,
  open: PropTypes.bool.isRequired,
  toggleConfirmDialog: PropTypes.func.isRequired,
  buttonTitle: PropTypes.string.isRequired,
};

ConfirmationAction.defaultProps = {
  hideCancelButton: true,
};

export default ConfirmationAction;



// WEBPACK FOOTER //
// ./src/components/OfferOverview/ReadyToInvestButton/ConfirmationAction.js